import React from "react";
import LogoImage from "./logo.svg";

interface LogoProps {
  className?: string;
}
export const Logo: React.FC<LogoProps> = ({ className }) => (
  <img className={className} alt="RAM Live" src={LogoImage} />
);
